import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M3.654 16.712a1.51 1.51 0 1 1 1.672 2.515 1.51 1.51 0 0 1-1.672-2.515Zm0-5.999a1.51 1.51 0 0 1 .836-.253v.03A1.52 1.52 0 0 1 6 12a1.51 1.51 0 1 1-2.346-1.287Zm0-6a1.51 1.51 0 0 1 .836-.253v.07A1.51 1.51 0 0 1 6 6a1.51 1.51 0 1 1-2.346-1.287Zm6.096.537a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75ZM9 12a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 12Zm.75 5.25a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextListBulletIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textListBullet')) as IconWithRender;

TextListBulletIcon.displayName = 'TextListBulletIcon';
TextListBulletIcon.propTypes = Icon.propTypes;
TextListBulletIcon.renderIcon = (props) => <TextListBulletIcon {...props} />;
export default TextListBulletIcon;
